type RemoteRef = {
    __initialized: boolean;
    init: (scope: Scope) => Promise<void>;
};

type Scope = unknown;
// eslint-disable-next-line camelcase
declare const __webpack_init_sharing__: (shareScope: string) => Promise<void>;
// eslint-disable-next-line camelcase
declare const __webpack_share_scopes__: {default: Scope};

/**
 * The Right Way to Load Dynamic Remotes
 * @author ScriptedAlchemy <zackary.l.jackson@gmail.com>
 * @see {@link https://gist.github.com/ScriptedAlchemy/3a24008ef60adc47fad1af7d3299a063}
 * @param remote - the remote global name
 * @param remoteFallbackUrl - fallback url for remote module
 */
export function getOrLoadRemote(remote: string, remoteFallbackUrl: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        // @ts-expect-error: `remote` is remote ref which is just a string
        if (!window[remote]) {
            const onload = async () => {
                // @ts-expect-error: `remote` is remote ref which is just a string
                const remoteRef: RemoteRef | undefined = window[remote];

                if (remoteRef && !remoteRef.__initialized) {
                    await __webpack_init_sharing__('default');

                    // eslint-disable-next-line camelcase
                    await remoteRef.init(__webpack_share_scopes__.default);
                    remoteRef.__initialized = true;
                }

                resolve();
            };

            const existingRemote = document.querySelector<HTMLScriptElement>(`[data-webpack="${remote}"]`);
            if (existingRemote) {
                // if existing remote but not loaded, hook into its onload and wait for it to be ready
                existingRemote.addEventListener('load', onload);
                existingRemote.addEventListener('error', reject);
                // check if remote fallback exists as param passed to function
            } else if (remoteFallbackUrl) {
                // inject remote if a fallback exists and call the same onload function
                const script = document.createElement('script');

                // mark as data-webpack so runtime can track it internally
                script.dataset.webpack = remote;
                script.async = true;
                script.addEventListener('load', onload);
                script.addEventListener('error', reject);
                script.src = remoteFallbackUrl;
                document.getElementsByTagName('head')[0].appendChild(script);
            } else {
                // no remote and no fallback exist, reject
                reject(new Error(`Cannot Find Remote ${remote} to inject`));
            }
        } else {
            // remote already instantiated, resolve
            resolve();
        }
    });
}
